import Vuex from 'vuex';
import Vue from 'vue';
import { SET_ALERTAS } from './mutation-types';
import { moduleVeiculo } from './vuex-modules/veiculos.vuex';
import { modulePositions } from './vuex-modules/positions.vuex';
import {Login} from './class/login';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        idAlerta: 0,
        auth: false
    },
    modules: {
        veiculo: moduleVeiculo,

        posicao: modulePositions
    },
    mutations: {
        [SET_ALERTAS] (state, id) {
            state.idAlerta = id;
        },

        setAuth (state, value) {
            state.auth = value;
        },

        logout(state) {
            Login.logout();
            window.localStorage.clear();
            state.auth = false;
        }
    }
});
